const values = [
  {
    icon: 'ri-flashlight-line',
    title: '빠른 대응',
    desc: '간병 요청 접수 후 신속하게 적합한 간병인을 배정합니다. 긴급 상황에도 24시간 대응 체계를 갖추고 있습니다.',
    highlight: '24시간 대응',
  },
  {
    icon: 'ri-user-heart-line',
    title: '고객 맞춤형 서비스',
    desc: '환자의 상태, 병원 환경, 보호자 요구사항을 꼼꼼히 파악하여 최적의 간병인을 연결해 드립니다.',
    highlight: '1:1 맞춤 매칭',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: '업계 최저 수수료',
    desc: '업계 최저 수준의 수수료 일 4,000원으로 부담 없이 전문 간병 서비스를 이용하실 수 있습니다. 최소 10,000원, 기간에 상관없이 최대 100,000원으로 책정되며, 기본 간병인 1명을 기준으로 간병인이 추가되면 1명당 10,000원이 더해집니다.',
    highlight: '4,000원/일 · 최소 1만~최대 10만원',
  },
  {
    icon: 'ri-file-shield-2-line',
    title: '간병보험 서류 발급',
    desc: '간병 완료 후 보험 청구에 필요한 서류를 신속하고 정확하게 발급해 드립니다. 복잡한 행정 절차를 대신 처리합니다.',
    highlight: '원스톱 처리',
  },
];

export default function IntroMission() {
  return (
    <section className="w-full py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top: Mission statement */}
        <div className="flex flex-col lg:flex-row gap-16 items-center mb-20">
          <div className="w-full lg:w-1/2">
            <p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{ color: '#2E7D6B' }}>OUR MISSION</p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-6">
              환자와 가족 모두가<br />
              <strong style={{ color: '#2E7D6B' }}>안심할 수 있는 간병</strong>을<br />
              만들어 갑니다
            </h2>
            <p className="text-sm leading-relaxed text-gray-500 mb-6">
              코리아케어러스는 간병이 필요한 환자와 그 가족들의 불안을 덜어드리기 위해 설립되었습니다.
              복잡한 보험 청구 절차, 믿을 수 있는 간병인 찾기, 필요 서류 준비까지 — 이 모든 과정에서
              전문가가 함께합니다.
            </p>
            <p className="text-sm leading-relaxed text-gray-500 mb-6">
              현재는 간병 진행 후 <strong className="text-gray-700">간병보험 서류 발급</strong>을 핵심 서비스로 제공하며,
              향후 <strong className="text-gray-700">간병 매칭 앱</strong> 개발을 통해 더욱 편리한 서비스로 발전해 나갈 예정입니다.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <div
                className="flex items-center gap-2 px-4 py-2 rounded-full text-xs font-semibold"
                style={{ backgroundColor: 'rgba(46,125,107,0.1)', color: '#2E7D6B' }}
              >
                <i className="ri-smartphone-line text-sm"></i>
                간병 매칭 앱 개발 예정
              </div>
              <div
                className="flex items-center gap-2 px-4 py-2 rounded-full text-xs font-semibold"
                style={{ backgroundColor: 'rgba(46,125,107,0.1)', color: '#2E7D6B' }}
              >
                <i className="ri-file-text-line text-sm"></i>
                보험서류 발급 서비스 운영 중
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2 rounded-2xl overflow-hidden" style={{ height: '380px' }}>
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20professional%20caregiver%20warmly%20holding%20elderly%20patient%20hand%20in%20bright%20sunlit%20hospital%20room%2C%20compassionate%20human%20connection%2C%20green%20and%20white%20clean%20environment%2C%20soft%20natural%20light%2C%20emotional%20and%20heartfelt%20scene%2C%20photorealistic%20high%20quality&width=700&height=380&seq=kc_mission1&orientation=landscape"
              alt="코리아케어러스 미션"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Values grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((v, i) => (
            <div
              key={i}
              className="rounded-2xl p-6 border border-gray-100 transition-all duration-300 group cursor-default"
              style={{ backgroundColor: '#f9fdfb' }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLDivElement).style.backgroundColor = '#2E7D6B';
                (e.currentTarget as HTMLDivElement).style.borderColor = 'transparent';
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLDivElement).style.backgroundColor = '#f9fdfb';
                (e.currentTarget as HTMLDivElement).style.borderColor = '#f3f4f6';
              }}
            >
              <div
                className="w-10 h-10 flex items-center justify-center rounded-xl mb-4 transition-colors duration-300"
                style={{ backgroundColor: 'rgba(46,125,107,0.12)' }}
              >
                <i className={`${v.icon} text-lg`} style={{ color: '#2E7D6B' }}></i>
              </div>
              <div
                className="inline-block text-xs font-bold px-2.5 py-1 rounded-full mb-3 group-hover:bg-white/20 transition-colors duration-300"
                style={{ backgroundColor: 'rgba(46,125,107,0.1)', color: '#2E7D6B' }}
              >
                {v.highlight}
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-2 group-hover:text-white transition-colors duration-300">{v.title}</h3>
              <p className="text-xs leading-relaxed text-gray-500 group-hover:text-white/75 transition-colors duration-300">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
